import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAsciinemaComponent } from './simple-icons-asciinema.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAsciinemaComponent ],
    exports:      [ SimpleIconsAsciinemaComponent ],
    bootstrap:    []
})
export class SimpleIconsAsciinemaModule {}
